module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9DLAm"))).then(() => parcelRequire('d0iPb'));